import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { providersService } from './providers.service';
import { handleThunkError } from '../helpers/thunkError';

const initialState = {
  advisorCodes: [],
  loadingAdvisorCodes: false,
  providers: [],
  providerAdvisors: [],
  advisors: [], // ✅ new
  loading: false,
  loadingAdvisors: false,
  loadingAllAdvisors: false, // optional but better
  error: null
};

export const getAdvisorCodes = createAsyncThunk(
  'providers/getAdvisorCodes',
  async (advisorId, thunkAPI) => {
    try {
      return await providersService.getAdvisorCodes(advisorId);
    } catch (error) {
      return handleThunkError(error, thunkAPI, 'Failed to fetch advisor codes');
    }
  }
);

// --- GET PROVIDERS ---
export const getProviders = createAsyncThunk('providers/getProviders', async (_, thunkAPI) => {
  try {
    return await providersService.getProviders();
  } catch (error) {
    return handleThunkError(error, thunkAPI, 'Failed to fetch providers');
  }
});

// --- GET ADVISORS FOR PROVIDER ---
export const getAdvisorsForProvider = createAsyncThunk(
  'providers/getAdvisorsForProvider',
  async (providerId, thunkAPI) => {
    try {
      return await providersService.getAdvisorsForProvider(providerId);
    } catch (error) {
      return handleThunkError(error, thunkAPI, 'Failed to fetch providers');
    }
  }
);

export const getAdvisors = createAsyncThunk('providers/getAdvisors', async (_, thunkAPI) => {
  try {
    return await providersService.getAdvisors();
  } catch (error) {
    return handleThunkError(error, thunkAPI, 'Failed to fetch advisors');
  }
});

export const providersSlice = createSlice({
  name: 'providers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // --- GET PROVIDERS ---
      .addCase(getProviders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProviders.fulfilled, (state, action) => {
        state.loading = false;
        state.providers = action.payload;
      })
      .addCase(getProviders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // --- GET ADVISORS ---
      .addCase(getAdvisorsForProvider.pending, (state) => {
        state.loadingAdvisors = true;
        state.error = null;
      })
      .addCase(getAdvisorsForProvider.fulfilled, (state, action) => {
        state.loadingAdvisors = false;
        state.providerAdvisors = action.payload;
      })
      .addCase(getAdvisorsForProvider.rejected, (state, action) => {
        state.loadingAdvisors = false;
        state.error = action.payload;
      })

      // --- GET ALL ADVISORS (PARTNERS) ---
      .addCase(getAdvisors.pending, (state) => {
        state.loadingAllAdvisors = true;
        state.error = null;
      })
      .addCase(getAdvisors.fulfilled, (state, action) => {
        state.loadingAllAdvisors = false;
        state.advisors = action.payload;
      })
      .addCase(getAdvisors.rejected, (state, action) => {
        state.loadingAllAdvisors = false;
        state.error = action.payload;
      })
      // --- GET ADVISOR CODES ---
      .addCase(getAdvisorCodes.pending, (state) => {
        state.loadingAdvisorCodes = true;
        state.error = null;
      })
      .addCase(getAdvisorCodes.fulfilled, (state, action) => {
        state.loadingAdvisorCodes = false;
        state.advisorCodes = action.payload;
      })
      .addCase(getAdvisorCodes.rejected, (state, action) => {
        state.loadingAdvisorCodes = false;
        state.error = action.payload;
      });
  }
});

export default providersSlice.reducer;
